import React from 'react'
import ClientDetailsReport from './ClientDetailsReport'
import { useStateContext } from '../context/StateContext';
import DeviceFamilyReport from './DeviceFamilyReport';

const RegisterInfo = ({register, devices, deviceNonConformities, registerTemplate}) => {
    const {client} = useStateContext();
    
    const testFunction = () => {
        console.log("SITE INFO TEST", devices, deviceNonConformities)
    }
    const registerDetails = {
        devices: devices?.filter?.((x)=>x?.register?._ref == register?._id),
        deviceNonConformities: deviceNonConformities?.filter?.((x)=>x?.register?._ref == register?._id), 
        hideLegenda: true, 
        hideClientsAndSites: true,
        //showToSupply: true,
        registerTemplate,
        client
    }
  return (
    <div>
        <h2 onClick={testFunction}>INFORMAZIONI REGISTRO</h2>
        <ClientDetailsReport data = {registerDetails}/>
        <DeviceFamilyReport register = {register} registerTemplate = {registerTemplate} />
  
    </div>
  )
}

export default RegisterInfo
